export default __webpack_public_path__ + "static/media/view-icon.fe3a2dd7.svg";